import { Component, OnInit } from '@angular/core';
import { Subscription, Observable, timer } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { ProgressBarService } from '../../services/progress-bar.service';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.css']
})
export class ProgressBarComponent implements OnInit {

  private refreshInterval: number = 200; // 100ms
  private timer: Observable<number>;
  isRunning: boolean = false;
  width: number = 35;

  constructor(
    private progressBarService: ProgressBarService
  ) { }

  ngOnInit() {
    this.progressBarService.isLoading$.subscribe((isLoading) => {
      this.isRunning = isLoading;
      if (isLoading) {
        this.initProgressBar();
      }
    });
  }

  private initProgressBar() {
    this.width = 35;
    this.timer = timer(0, this.refreshInterval);
    this.timer // Load data in loop by refreshInterval
      .pipe(
        takeWhile(() => this.isRunning)
      )
      .subscribe(() => {
        this.width += 10;
      });
  }

}
